import { render } from "./history-page.vue?vue&type=template&id=00a4d949"
import script from "./history-page.vue?vue&type=script&lang=js"
export * from "./history-page.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__